;(function() {
// Pulls birth date and id number from a matching person found in previous orders.
/* @ngInject */
function PersonDataPullerController(Helpers) {
  let vm = this;

  vm.$onInit = () => {
    vm.checkboxId = "checkboxOldData" + vm.index;
  };

  vm.$onChanges = () => {
    vm.oldDataPerson = getOldDataPerson();
  };

  function getOldDataPerson() {
    let personFromOldOrder;

    (vm.personsFromOldOrders || []).forEach(oldP => {
      if (vm.person && oldP.firstName === vm.person.name && oldP.lastName === vm.person.surname)
        personFromOldOrder = oldP;
    });

    return personFromOldOrder;
  }

  vm.setOldData = (person, event) => {
    if (event.target.checked) {
      vm.person.dateOfBirth = person.dateOfBirth;
      vm.person.idNumber = person.idNumber;
    } else {
      vm.person.dateOfBirth = {};
      vm.person.idNumber = {};
    }
  };

  vm.dateToString = Helpers.dateToString;
}

angular.module("firmaren")
  .component("personDataPuller", {
    templateUrl: "/app/shared/person-data-puller/person-data-puller.html",
    controller: PersonDataPullerController,
    controllerAs: "vm",
    bindings: {
      index: "<",
      person: "=",
      personsFromOldOrders: "<"
    }
  });
}());
